import { Directive, HostListener, Input } from "@angular/core";
import { GoogleAnalyticsService } from "@core/services/google-analytics.service";

@Directive({
    selector: "[appOnClickGa]",
    standalone: false
})
export class OnClickGaDirective {
  @Input() buttonName: string;

  constructor(private googleAnalyticsService: GoogleAnalyticsService) {}

  @HostListener("click") onClick(): void {
    this.googleAnalyticsService.sendEvent(this.buttonName);
  }
}
